/** Growth is a percent number: 15 means 15%, not 0.15. Never use price CAGR here. */
export function forwardPeg(forwardPe: number, annualEarningsGrowthPercent: number): number | null {
  if (!Number.isFinite(forwardPe) || !Number.isFinite(annualEarningsGrowthPercent) ||
      forwardPe <= 0 || annualEarningsGrowthPercent <= 0) return null;
  const peg = forwardPe / annualEarningsGrowthPercent;
  return Number.isFinite(peg) && peg > 0 ? peg : null;
}
